import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { reduxForm, Field } from 'redux-form'
import QS from 'qs'
import { validators, PASSWORD_LENGTH_MAX } from '@adalo/constants'
import {
  GoogleReCaptchaProvider,
  withGoogleReCaptcha,
} from 'react-google-recaptcha-v3'

import Button from '../Shared/Button'
import WrappedInput from '../Shared/Forms/WrappedInput'
import CheckboxRow from '../Shared/Forms/CheckboxRow'
import AuthPageLogo from './Logo'

const FORM_NAME = 'signupForm'

export const validate = data => {
  const errors = {}

  if (!data.email) {
    errors.email = 'Email is required'
  } else if (!data.email.match(validators.email)) {
    errors.email = 'Please enter a valid email address'
  }

  if (!data.name) {
    errors.name = 'Name is required'
  }

  if (data.name && !data.name.match(validators.name)) {
    errors.name = 'Name has unsupported characters'
  }

  if (!data.password || data.password.length < 8) {
    errors.password = 'Password must be at least 8 characters'
  }

  if (data.password && data.password.length > PASSWORD_LENGTH_MAX) {
    errors.password = 'Password is too long'
  }

  if (
    data.password &&
    data.password.length >= 8 &&
    !data.password.match(validators.password)
  ) {
    errors.password = 'Password has unsupported characters'
  }

  if (!data.terms) {
    errors.terms = 'You must accept the Terms of Use'
  }

  return errors
}

class SignupForm extends Component {
  getTermsURL = () => {
    let { pathname, search } = window.location

    pathname = pathname.replace(/\/$/, '')
    const terms = pathname.includes('/terms') ? '' : '/terms'

    return `${pathname}${terms}${search}`
  }

  handleVerifyRecaptcha = async event => {
    event.preventDefault()
    event.persist()

    const { googleReCaptchaProps, handleSubmit, change } = this.props
    const { executeRecaptcha } = googleReCaptchaProps || {}

    if (!executeRecaptcha) {
      console.log('ReCaptcha has not been loaded')

      return
    }

    const token = await executeRecaptcha('signup')

    if (!token) {
      console.info('Invalid user detected by ReCaptcha')

      return
    }

    change('token', token)
    await handleSubmit()
  }

  render() {
    const { submitFailed, error, isInvite, submitting, redirect } = this.props
    const redirectQuery = QS.stringify({ redirect }, { addQueryPrefix: true })

    return (
      <form onSubmit={this.handleVerifyRecaptcha} className="auth-form">
        <AuthPageLogo />
        <h1>Sign Up For Free!</h1>
        <Field
          autoFocus={!isInvite}
          disabled={isInvite}
          name="email"
          placeholder="elon@spacex.com"
          type="email"
          label="Email Address"
          component={WrappedInput}
          autoComplete="email"
          maxLength={255}
        />
        <Field
          autoFocus={isInvite}
          name="password"
          placeholder="••••••••"
          type="password"
          label="Password"
          component={WrappedInput}
          autoComplete="new-password"
        />
        <Field
          name="name"
          placeholder="Elon Musk"
          type="text"
          component={WrappedInput}
          label="Full Name"
          autoComplete="name"
          maxLength={255}
        />
        <Field
          yellow
          name="terms"
          component={CheckboxRow}
          label={
            <span>
              {'I have read & agree to '}
              <Link to={this.getTermsURL()}>Adalo’s Terms of Use</Link>
            </span>
          }
          autoComplete="off"
        />
        <div className="auth-form-submission-row">
          <Button large yellow loading={submitting}>
            Let’s Do This!
          </Button>
        </div>
        {error && submitFailed && (
          <div className="auth-form-error">{error}</div>
        )}
        <div className="auth-form-link">
          {'Already have an account? '}
          <Link to={`/login${redirectQuery}`} className="link-button">
            Login
          </Link>
        </div>
      </form>
    )
  }
}

const wrappedSignupForm = reduxForm({
  form: FORM_NAME,
  validate,
})(SignupForm)

const SignupFormWithReCaptcha = withGoogleReCaptcha(wrappedSignupForm)

export default props => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
    <SignupFormWithReCaptcha {...props} />
  </GoogleReCaptchaProvider>
)
